import { Controller } from 'stimulus';
import Animation from 'src/animation';

import sprite1 from 'images/animations/number_of_tires/1.png';
import sprite2 from 'images/animations/number_of_tires/2.png';
import sprite3 from 'images/animations/number_of_tires/3.png';
import sprite4 from 'images/animations/number_of_tires/4.png';

export default class extends Controller {
  connect() {
    const ratio = 1.378;

    const options = {
      canvasWidth: this.element.offsetWidth,
      canvasHeight: this.element.offsetWidth / ratio,
      sources: this.sources,
      steps: this.steps,
      element: this.element
    };

    let rangeEl = this.element.querySelector('input')

    rangeEl.min = 0;
    rangeEl.max = 3;
    rangeEl.step = 1;
    rangeEl.value = 0;

    const animation = new Animation(options);

    let initialSprite = new Image();
    initialSprite.src = sprite1;
    initialSprite.onload = function() {
      animation.render(0)
    }
  }

  get sources() {
    return [
      sprite1,
      sprite2,
      sprite3,
      sprite4
    ]
  }

  get steps() {
    return [
      'Single tires are the easiest to maneuver and usually used for the steer axle. As in the example above, 650 pounds per inch on a standard 11” tire on an axle with one tire on each side will get you a <i>650*11*2</i>=14,300 pounds limit on that axle.',
      "If you add another pair of 11” tires on that axle, (so 2 on each side), your tire weight limit would be <i>650*11*4</i>=28,600",
      'If you had six 11” tires on that axle, (3 on each side), your tire weight limit for that axle would be <i>650*11*6</i>=42,900.',
      'You can keep adding more and more tires to the axle, but mind that a high tire weight limit does not mean that you can carry that full weight on a single axle, as there is still a separate single axle weight limit that is never that high, and you’ll be limited to the lesser of the two.'
    ]
  }
}
